import { render, staticRenderFns } from "./TabelaProdutos.vue?vue&type=template&id=3148164c&scoped=true"
import script from "./TabelaProdutos.vue?vue&type=script&lang=js"
export * from "./TabelaProdutos.vue?vue&type=script&lang=js"
import style0 from "@/assets/admin-styles.css?vue&type=style&index=0&id=3148164c&prod&scoped=true&lang=css&external"
import style1 from "./TabelaProdutos.vue?vue&type=style&index=1&id=3148164c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3148164c",
  null
  
)

export default component.exports